import React from 'react'
import { Navbar, Form } from './components'
import './home.css'

const Home = () => {
  return (
      <div className='nav_form_container'>
        <Navbar />
        <Form />
      </div>
  )
}

export default Home